function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0-banktransfers-01{fill:none;stroke:#000000;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  className: "st0-banktransfers-01",
  x1: 39.1,
  y1: 11.7,
  x2: 27.8,
  y2: 11.7
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st0-banktransfers-01",
  points: "31.3,15.3 27.8,11.7 31.3,8.2  "
}));

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  className: "st0-banktransfers-01",
  x1: 27.8,
  y1: 18.5,
  x2: 39.1,
  y2: 18.5
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st0-banktransfers-01",
  points: "35.5,15 39.1,18.5 35.5,22  "
}));

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "st0-banktransfers-01",
  d: "M32.2,22.9c0,6.8-5.5,12.3-12.3,12.3S7.7,29.6,7.7,22.9s5.5-12.3,12.3-12.3c1.3,0,2.5,0.2,3.7,0.6"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "st0-banktransfers-01",
  d: "M23,19.8c0,0-1.1-2.4-3.2-2.4s-2.7,2-2.7,2.6s0.3,2.4,3.5,2.8c3.1,0.4,2.6,2.9,2.7,3.2c0,0.7-1,2.2-3.1,2.2 c-2.7,0-3.1-2.7-3.1-2.7"
});

var _ref7 = /*#__PURE__*/React.createElement("line", {
  className: "st0-banktransfers-01",
  x1: 19.9,
  y1: 15.9,
  x2: 19.9,
  y2: 29.5
});

var SvgBanktransfers01 = function SvgBanktransfers01(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBanktransfers01, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/banktransfers-01.bb200ba4.svg";
export { ForwardRef as ReactComponent };